export { Ellipsified } from "./Ellipsified";
